import { render, staticRenderFns } from "./BusinessOfferingsView.vue?vue&type=template&id=c681a59c"
import script from "./BusinessOfferingsView.vue?vue&type=script&lang=js"
export * from "./BusinessOfferingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports